<db-dialog-wrapper [dialog]="this" [width]="'500px'" [height]="'200px'">
  <div class="db-reset_password">
    <div class="db-reset_password__update">
      <form [formGroup]="cancelForm" >
        <h2>{{'text_resetPassword' | dbText}}</h2>
        <p>{{'text_resetPasswordSure' | dbText}}</p>
        <div class="db-buttons">
          <a class="ds-btn ds-btn-m" (click)="close()"><span>{{'text_cancel' | dbText}}</span></a>
          <a class="ds-btn ds-btn-m ds-btn-blue" (click)="submitReset()">
            <span *ngIf="!loading">{{'text_reset' | dbText | lowerCaseSpecificWords}}</span>
            <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
          </a>
        </div>
      </form>
    </div>
  </div>
</db-dialog-wrapper>
